export { default } from './Shelf';



// WEBPACK FOOTER //
// ./app/components/shelves/Shelf/index.js